(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7PKI7", function(module, exports) {

$parcel$export(module.exports, "bootBlock", function () { return $5b418790771612cf$export$3ba659c19d85cb2f; });
$parcel$export(module.exports, "scoped", function () { return $5b418790771612cf$export$6387ff77edd805b9; });
$parcel$export(module.exports, "claim", function () { return $5b418790771612cf$export$dac5a380ed022e46; });
$parcel$export(module.exports, "listenWhileConnected", function () { return $5b418790771612cf$export$1739974940b15ce8; });
/**
 * Shared boot for the theme block scripts (blocks/*).
 *
 * Every block script keeps its behavior in one initializer, `initialize(root, options)`:
 * - Frontend: called once with the whole document after DOMContentLoaded (or right away when the document
 *   is already parsed), or after `load` for scripts that always waited for it.
 * - Block editor canvas: handed to the canvas runtime (inc/Blocks/block-canvas.js), which calls it with the
 *   preview root after every ACF preview render, with { isEditor: true, autoplay: false }.
 *
 * ACF re-renders previews by reconciling the same DOM, so initializers run repeatedly: bind through claim()
 * so each element is wired once, and remove window/document listeners when the block leaves the canvas.
 */ function $5b418790771612cf$export$3ba659c19d85cb2f(slug, initialize) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_waitFor = _ref.waitFor, waitFor = _ref_waitFor === void 0 ? 'DOMContentLoaded' : _ref_waitFor;
    if (window.juniperBlockRuntime) {
        window.juniperBlockRuntime.register(slug, initialize);
        return;
    }
    var run = function() {
        return initialize(document, {
            isEditor: false,
            autoplay: true
        });
    };
    if (waitFor === 'load') {
        if (document.readyState === 'complete') run();
        else window.addEventListener('load', run, {
            once: true
        });
    } else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {
        once: true
    });
    else run();
}
function $5b418790771612cf$export$6387ff77edd805b9(root, selector) {
    return root.nodeType === Node.DOCUMENT_NODE ? selector : root.querySelector(selector);
}
function $5b418790771612cf$export$dac5a380ed022e46(element) {
    var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'juniperReady';
    if (!element || element.dataset[key] === 'true') return false;
    element.dataset[key] = 'true';
    return true;
}
function $5b418790771612cf$export$1739974940b15ce8(target, type, handler, owner, options) {
    var listener = function(event) {
        if (!owner.isConnected) {
            target.removeEventListener(type, listener, options);
            return;
        }
        handler(event);
    };
    target.addEventListener(type, listener, options);
}

});


var $7PKI7 = parcelRequire("7PKI7");
var $47d9943ff8a24443$var$blogNewsletter = {
    init: function init(root, param) {
        var isEditor = param.isEditor;
        var newsletter = root.querySelector('.newsletter-blog');
        // Editor: the page layout this adapts to does not exist in the canvas, and the form must not
        // subscribe anyone; the preview keeps the form's own markup and input behavior.
        if (newsletter && !isEditor) {
            this.style(newsletter);
            this.takeoverFormOperation();
        }
    },
    takeoverFormOperation: function() {
        var form = document.querySelector('.newsletter-blog form');
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            grecaptcha.ready(function() {
                grecaptcha.execute(recaptcha.recaptcha_widget_id, {
                    action: 'submit'
                }).then(function(token) {
                    document.getElementById('g-recaptcha-response-newsletter').value = token;
                    var ajax_data = {
                        action: 'join-newsletter',
                        email: document.querySelector('.newsletter-blog form input[type="email"]').value,
                        recaptchaToken: token
                    };
                    var loader = document.querySelector('.newsletter-blog').nextElementSibling;
                    jQuery.ajax({
                        type: 'POST',
                        url: main_ajax.ajax_url,
                        data: ajax_data,
                        beforeSend: function beforeSend() {
                            loader === null || loader === void 0 ? void 0 : loader.classList.add('var_active');
                        },
                        success: function(data) {
                            var json = JSON.parse(data.results);
                            if (typeof json.inlineMessage !== 'undefined') {
                                var message = document.querySelector('.newsletter-blog__callback p');
                                var newsletter = document.querySelector('.newsletter-blog');
                                message.innerHTML = json.inlineMessage;
                                newsletter.classList.add('var_message');
                            }
                        },
                        error: function(xhr, status, errorThrown) {
                            console.log(status, 'Custom ajax status', errorThrown, 'Custom ajax error');
                        },
                        complete: function complete() {
                            loader === null || loader === void 0 ? void 0 : loader.classList.remove('var_active');
                        }
                    });
                });
            });
        });
    },
    style: function(newsletter) {
        var lastMainChild = document.querySelector('main .content-wrapper').lastElementChild;
        var isLastChildContainsBackground = /background/.test(lastMainChild.className);
        if (isLastChildContainsBackground) {
            newsletter.classList.add('var_no-margin');
            lastMainChild.classList.add('var_padding-bottom');
        }
    }
};
(0, $7PKI7.bootBlock)('blog-newsletter', function(root, options) {
    return $47d9943ff8a24443$var$blogNewsletter.init(root, options);
});

})();
//# sourceMappingURL=script.js.map
